import React, { useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import GrievanceModal from "./GrievanceModal";
import "swiper/css";

const PartnerSection = ({ bankCarouselItems, isMobile }) => {
  const swiperRef = useRef(null);
  const [showModal, setShowModal] = useState(false);

  const handleClick = (bank) => {
    console.log("Clicked bank:", bank);
    if (bank === 7) {
      setShowModal(true);
    }
  };

  const handleClose = () => setShowModal(false);

  // Duplicate slides if less than slidesPerView for proper loop
  const slides =
    bankCarouselItems.length < (isMobile ? 1 : 4)
      ? [...bankCarouselItems, ...bankCarouselItems]
      : bankCarouselItems;

  return (
    <section className="lender-content-section">
      <div className="inside-lender">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              <h2 className="someofthebest">
                SOME OF THE TOP LENDERS, WHO ARE EAGER TO LEND YOU
              </h2>
            </div>
          </div>
        </div>
      </div>

      <div className="lender-black">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              <h4>
                Explore Loan Options from Respected RBI-Regulated Lenders to
                Support Your Financial Requirements.
              </h4>

              <div
                onMouseEnter={() => swiperRef.current?.autoplay.stop()}
                onMouseLeave={() => swiperRef.current?.autoplay.start()}
              >
                <Swiper
                  modules={[Autoplay]}
                  slidesPerView={isMobile ? 1 : 4}
                  loop={true}
                  autoplay={{ delay: 1500, disableOnInteraction: false }}
                  spaceBetween={20}
                  onSwiper={(swiper) => (swiperRef.current = swiper)}
                >
                  {slides.map((item, index) => (
                    <SwiperSlide
                      key={index}
                      onClick={() => handleClick(item.id)}
                      style={{
                        cursor: "pointer",
                        height: "95px",
                        display: "flex",
                        border: "1px solid #373636",
                        borderRadius: "5px",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <img
                        src={item.img}
                        alt={item.name}
                        className="img-fluid"
                        loading="lazy"
                        style={{
                          maxWidth: "100%",
                          height: "auto",
                          /*filter: "grayscale(100%)",
                          opacity: "0.5",*/
                        }}
                      />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          </div>
        </div>
      </div>

      <GrievanceModal show={showModal} onHide={handleClose} />
    </section>
  );
};

export default PartnerSection;
